var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewWishlists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.14 3.11c-.99 0-1.96.27-2.79.79-.94.63-1.74 1.44-2.35 2.4a7.603 7.603 0 0 0-2.31-2.38c-.85-.54-1.83-.82-2.83-.82h-.17A4.779 4.779 0 0 0 2 7.99c0 .75.15 1.49.42 2.19.37.9.87 1.75 1.48 2.51a33.78 33.78 0 0 0 2.88 3.22c1.2 1.21 2.73 2.67 4.58 4.38l.64.58.64-.58c1.85-1.7 3.39-3.17 4.6-4.39a33.78 33.78 0 0 0 2.88-3.22c.61-.76 1.1-1.6 1.47-2.5.27-.7.41-1.44.42-2.19v-.17a4.791 4.791 0 0 0-4.86-4.72Zm3.6 6.91a9.76 9.76 0 0 1-1.44 2.35c-.88 1.08-1.81 2.12-2.81 3.1-1.18 1.19-2.67 2.61-4.49 4.28-1.81-1.67-3.32-3.09-4.5-4.26-1-.97-1.94-2.01-2.81-3.1-.58-.72-1.06-1.51-1.43-2.36A5.4 5.4 0 0 1 2.86 8v-.2a3.919 3.919 0 0 1 4-3.83c.92 0 1.81.28 2.56.82.9.69 1.66 1.55 2.22 2.54h.72c.55-.99 1.29-1.86 2.19-2.54.75-.54 1.66-.82 2.58-.82h.24c2.15.07 3.83 1.88 3.76 4.03 0 .7-.14 1.38-.4 2.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewWishlists);
export default __webpack_public_path__ + "static/media/Overview - Wishlists.7cf4f05b2bc363eda4f4f453e05fb86d.svg";
export { ForwardRef as ReactComponent };